import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../service/caller';
import Select from 'react-select';
import './newanalyse.css';  // Assurez-vous d'avoir ce fichier CSS dans le même répertoire

const ServiceSelection = ({ onServicesChange }) => {
    const [services, setServices] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [appointmentData, setAppointmentData] = useState([]);
    const [error, setError] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const patientId = queryParams.get('patient_id');
    const appointmentId = queryParams.get('appointmentId');
    const departmentId = appointmentData.department;

    // Fonction pour récupérer les services
    const fetchServices = async () => {
        try {
            const response = await api.get('api/services');
            console.log('serv',response.data);
            const serviceOptions = response.data.data.map(service => ({
                value: service._id,
                label: `${service.name} - ${service.price_service}`,
                price: service.price_service,
                name: service.name,
                id: service._id,
            }));
            setServices(serviceOptions); // Mettre à jour l'état des services
        } catch (err) {
            setError('Erreur lors de la récupération des services');
            console.error(err);
        } finally {
            setLoading(false); // Mettre à false une fois l'appel terminé
        }
    };

    useEffect(() => {
        fetchServices(); 
    }, []); 

    const fetchAvailableAppointments = async () => {
        try {
            const response = await api.get(`/clinic/getappointment/${appointmentId}`);
            setAppointmentData(response.data.appointment);
        } catch (error) {
            console.error(error.message);
            setError('Erreur lors de la récupération des données du rendez-vous');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (appointmentId) {
            fetchAvailableAppointments();
        }
    }, [appointmentId]);

    const handleServiceChange = (selectedOptions) => {
        setSelectedServices(selectedOptions);
        onServicesChange(selectedOptions); // Passer les services sélectionnés au parent
    };

    const renderSelectedServicesTable = () => {
        const total = selectedServices.reduce((acc, option) => {
            const price = parseFloat(option.price.replace(/[^0-9.-]+/g, ''));
            return acc + price;
        }, 0);

        return (
            <table className="service-table">
                <thead>
                    <tr>
                        <th>Nom du Service</th>
                        <th>Prix</th>
                    </tr>
                </thead>
                <tbody>
                    {selectedServices.map((service, index) => (
                        <tr key={index}>
                            <td>{service.name}</td>
                            <td>{service.price}</td>
                        </tr>
                    ))}
                    <tr className="total-row">
                        <td><strong>Total</strong></td>
                        <td><strong>{total} FCFA</strong></td>
                    </tr>
                </tbody>
            </table>
        );
    };

    return (
        <div className="service-selection-container">
            <div className="position-relative">
                <p className="py-3 fw-bold ms-5" onClick={() => setIsOpen(!isOpen)}>
                    Services
                    <i className="bi bi-caret-down-fill" style={{ color: '#FF9800' }}></i>
                </p>
            </div>

            {isOpen && (
                <div className="service-dropdown">
                    <h6 className="service-title" tyle={{ color: '#FF9800' }}>Sélectionnez les services fournis aux patients</h6>

                    <Select
                        isMulti
                        options={services}
                        onChange={handleServiceChange}
                        getOptionLabel={(e) => `${e.label}`}
                        placeholder="Rechercher un service..."
                        className="react-select"
                    />

                    {selectedServices.length > 0 && renderSelectedServicesTable()}
                </div>
            )}
        </div>
    );
};

export default ServiceSelection;
